import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./containers/Home";
import LoginPage from "./pages/Login";
import RegisterPage from "./pages/Register";
import { ROUTES } from "./constants/Routes";
import Customer from "./containers/Customer";
import Tracking from "./containers/Tracking";
import { store } from "./utils/redux/store";
import { useSelector } from "react-redux";
import AppLayout from "./containers/menu/AppLayout";
import NoLoginRoute from "./containers/menu/NoLoginRoute";
import ProtectedRoute from "./containers/menu/ProtectedRoute";
import CheckingStatusPark from "./containers/CheckingStatus";
import QueueParking from "./containers/QueueParking";

const MyRoutes = () => {
  // const state = useSelector((state) => state);
  // const states = store.getState();
  // const accessToken = state.authenReducer.accessToken;
  return (
    <BrowserRouter basename={`/`}>
      <Suspense fallback={<div />}>
        <Routes>
          <Route path={ROUTES.Slash} element={<AppLayout />}>
            {/* No authen route */}
            <Route path={ROUTES.Login} element={<NoLoginRoute />}>
              <Route path={ROUTES.Login} element={<LoginPage />} />
            </Route>
            {/* Authenticated routes */}
            <Route path={ROUTES.Slash} element={<ProtectedRoute />}>
              <Route path={ROUTES.Slash} element={<Home />} />
              <Route path={ROUTES.Home} element={<Home />} />
              <Route path={ROUTES.Customer} element={<Customer />} />
              <Route path={ROUTES.Tracking} element={<Tracking />} />
              <Route path={ROUTES.Queue} element={<QueueParking />} />
              <Route
                path={ROUTES.CheckingStatus}
                element={<CheckingStatusPark />}
              />
            </Route>
            <Route path={ROUTES.Register} element={<RegisterPage />} />
            <Route path="*" element={<Navigate to="/home" />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default MyRoutes;
